import { HttpRoutes } from 'utils/constant';

import { addUserGroupToData } from '../utils';

import Service from './service';

export const emailLogin = (payload) => {
  addUserGroupToData(payload);
  payload.signupPageUrl = window.location.href;
  return Service.post(HttpRoutes.emailLogin, payload)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      }
      return Promise.reject(new Error('error'));
    })
    .catch(function (error) {
      return Promise.reject(error.response.data);
    });
};

const resetPassword = (payload) =>
  Service.post(HttpRoutes.resetPassword, payload)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      }
      return Promise.reject(new Error('error'));
    })
    .catch((err) => Promise.reject(err));

/**
 * @param {Object} payload user signup information
 * @param {String} payload.email user's email
 * @param {String} payload.pageCategory page category
 * @param {String} payload.survey survey name
 * @param {String} payload.survey_step survey name
 * @param {String} payload.utm_campaign survey utm_campaign
 */
export const signUpAndContinue = (payload) => {
  payload.signupPageUrl = window.location.href;
  return Service.post(HttpRoutes.logInWithEmail, payload)
    .then((response) => {
      const { data } = response;
      if (data.SUCCESS) {
        return true;
      }
      if (data.userValidationError || data.triggerSignupRecaptcha) {
        return Promise.reject(data);
      }
      return Promise.reject(new Error('signUpAndContinue failed'));
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const signUpWithEmail = (payload) => {
  // this api will verify user exist or not
  addUserGroupToData(payload);
  payload.pageCategory = window.pageCategory;
  payload.signupPageUrl = window.location.href;
  return Service.post(HttpRoutes.emailSignUp, payload)
    .then((response) => {
      const { data = {} } = response;
      const { status } = data || {};
      if (status === 'SUCCESS') {
        return Promise.resolve(data);
      } else {
        return Promise.reject(data);
      }
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export const signUpWithOnlyEmail = (payload) => {
  payload.signupPageUrl = window.location.href;
  return Service.post(HttpRoutes.signUpWithEmail, payload)
    .then((response) => Promise.resolve(response.data))
    .catch((err) => Promise.reject(err));
};

export const getUserProfile = () =>
  Service.get(HttpRoutes.getUserProfile)
    .then((response) => {
      const { data } = response;
      if (data.profile) {
        return data.profile;
      }
      return Promise.reject(new Error('failed to get detail'));
    })
    .catch((err) => Promise.reject(err));

export const getSalaryReportProfile = () =>
  Service.get(HttpRoutes.getSalaryReportProfile)
  .then((response) => response.data)
  .catch((err) => Promise.reject(err));

export const deactivateAccount = (data) =>
  Service.post(HttpRoutes.deactivateAccount, data)
    .then((response) => response.data)
    .catch((err) => Promise.reject(err));

export const logDeleteUserActivity = (payload) => {
  const data = {
    activityType: 'DELETE_ACCOUNT',
    url: location.href,
    pageCategory: payload.pageCategory || window.pageCategory,
    companyID: payload.user.employerData && payload.user.employerData.companyID,
    deletedUserId: payload.user.userId,
  };
  addUserGroupToData(data);
  Service.post(HttpRoutes.logActivity, data);
};

export const resetNewPassword = (data) =>
  Service.post(HttpRoutes.resetNewPassword, data)
    .then((response) => response.data)
    .catch((err) => Promise.reject(err));

export const AuthService = {
  emailLogin,
  resetPassword,
  signUpAndContinue,
  getUserProfile,
  deactivateAccount,
  logDeleteUserActivity,
  getSalaryReportProfile
};
